"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuWrapper = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var Dropdown_1 = require("../Dropdown");
var ActionContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: fixed;\n\tleft: ", "px;\n\ttop: ", "px;\n\tz-index: 2000;\n"], ["\n\tposition: fixed;\n\tleft: ", "px;\n\ttop: ", "px;\n\tz-index: 2000;\n"])), function (props) { return props.xPosition; }, function (props) { return props.yPosition; });
ActionContainer.displayName = 'ActionContainer';
var ToggleDropDown = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: 32px;\n\twidth: 36px;\n\tborder-radius: 3px;\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-align: center;\n\t:hover {\n\t\tcursor: pointer;\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t}\n\t", "\n"], ["\n\theight: 32px;\n\twidth: 36px;\n\tborder-radius: 3px;\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\talign-items: center;\n\ttext-align: center;\n\t:hover {\n\t\tcursor: pointer;\n\t\tbackground: ", ";\n\t\tcolor: ", ";\n\t}\n\t", "\n"])), globalVars_module_scss_1.default.mainBlue, globalVars_module_scss_1.default.white, function (props) { return (props.highlight ? 'background: ' + globalVars_module_scss_1.default.mainBlue : ''); });
ToggleDropDown.displayName = 'ToggleDropDown';
var ActionMenuIcon = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return (props.highlight ? 'color: #ffffff' : ''); });
var ActionMenuWrapper = /** @class */ (function (_super) {
    __extends(ActionMenuWrapper, _super);
    function ActionMenuWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { toggleDropDown: false, x: 0, y: 0 };
        _this.handleOnClick = _this.handleOnClick.bind(_this);
        _this.handleOnScroll = _this.handleOnScroll.bind(_this);
        _this.handleToggleDropDown = _this.handleToggleDropDown.bind(_this);
        return _this;
    }
    ActionMenuWrapper.prototype.UNSAFE_componentWillMount = function () {
        window.addEventListener('scroll', this.handleOnScroll);
    };
    ActionMenuWrapper.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.handleOnScroll);
    };
    ActionMenuWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(Dropdown_1.Dropdown, null,
                React.createElement(ToggleDropDown, { onClick: this.handleOnClick, highlight: this.state.toggleDropDown },
                    React.createElement(ActionMenuIcon, { highlight: this.state.toggleDropDown },
                        React.createElement(Common_1.Icon, { name: 'more-info' }))),
                React.createElement(ActionContainer, { xPosition: this.state.x, yPosition: this.state.y, onClick: function () { return _this.handleToggleDropDown(false); } },
                    React.createElement(Dropdown_1.DropdownMenu, { open: this.state.toggleDropDown, x: 0, y: 0, onBlur: function () { return _this.handleToggleDropDown(false); } }, this.props.children)))));
    };
    ActionMenuWrapper.prototype.handleOnClick = function (event) {
        var bounds = event.target.getBoundingClientRect();
        this.handleToggleDropDown(!this.state.toggleDropDown);
        this.setState({ x: bounds.left - 220, y: bounds.bottom - 82 });
    };
    ActionMenuWrapper.prototype.handleOnScroll = function () {
        this.handleToggleDropDown(false);
    };
    ActionMenuWrapper.prototype.handleToggleDropDown = function (setting) {
        this.setState({ toggleDropDown: setting });
    };
    return ActionMenuWrapper;
}(React.Component));
exports.ActionMenuWrapper = ActionMenuWrapper;
var templateObject_1, templateObject_2, templateObject_3;
